import { PRODUCT_DETAIL_SUCCESS } from 'actions/productDetailsActions';
import { INIT, SUCCESS } from 'utils/asyncStatusHelper';
import get from 'lodash/get';

const defaultState = {
	asyncStatus: INIT
};

export default function productLayout(state = defaultState, action) {
	switch (action.type) {
		case PRODUCT_DETAIL_SUCCESS:
			/* const layoutMeta = get(action, ['data', 'layout', 'page']);
			const layout = layoutMeta && layoutMeta.id &&
				get(action, ['data', 'productPageLayout', 'RESPONSE', layoutMeta.id, 'value']); */
			return Object.assign(
				{},
				state,
				{ asyncStatus: SUCCESS },
				{
					value: get(action, ['data', 'productPageLayout']) // since layout is stringified JSON
				}
			);

		default:
			return state;
	}
}
